export default __webpack_public_path__ + "static/media/godaddy_hosting_web.3b300040.webp";